module.exports = __webpack_public_path__ + "static/media/SM-ST-11.d2eabdc3.mp3";